import { Component, OnInit } from '@angular/core';

import {LogoPath} from '../../../core/constants/image';
@Component({
  selector: 'school-terms-condition',
  templateUrl: './terms-condition.component.html',
  styleUrls: ['./terms-condition.component.scss']
})
export class TermsConditionComponent implements OnInit {

  logopath:string = LogoPath;
  constructor() { }

  ngOnInit(): void {
    
  }

}
